export default __webpack_public_path__ + "static/media/element_spec_54.388c97cb.webp";